import { styled } from '@mui/system';

export const PageHeader = styled('div')(({ theme }) => ({
  textAlign: 'center',
  lineHeight: '2.75rem',
  padding: '8px 0px',
}));
